export default {
    caution: "Achtung",
    next: "Weiter",
    edit: "bearbeiten",
    yes: "Ja",
    no: "Nein",
    on: "An",
    off: "Aus",
    from: "von",
    day: "Tag",
    month: "Monat",
    year: "Jahr",
    to: "bis",
    booking: "Buchung",
    previewActive: "Sie sehen diese Anmeldung im Vorschaumodus. Die Anmeldung ist möglicherweise noch nicht freigeschaltet.",
    bookNowPayable: "Jetzt zahlungspflichtig buchen",
    bookNow: "Jetzt buchen",
    buyNow: "Jetzt zahlungspflichtig bestellen",
    saveGroupRegistration: "Gruppenanmeldung speichern",
    saveGroupBuy: "Gruppenbestellung speichern",
    orderNow: "Jetzt bestellen",
    someErrors: "Etwas stimmt noch nicht!",
    someErrorsExplanation: "Bitte korrigieren Sie folgende Felder:",
    done: "Fertig",
    someErrorsExplanationRegStepPage: "Bevor Sie zum nächsten Schritt gehen können, müssen Sie noch folgende Fehler korrigieren:",
    clickExplanation: "(Ein Klick auf eine der Schaltfächen, führt Sie zu dem fehlerhaften Feld)",

    registrationSuccessful: "Ihre Anmeldung wurde erfolgreich an uns übermittelt.",
    startOfGroupRegistrationSuccessful: "Ihre Gruppenanmeldung wurde erfolgreich erstellt.",
    groupRegistrationSavedSuccessful: "Ihre Gruppenanmeldung wurde erfolgreich gespeichert.",
    editGroupRegistration: "Gruppenanmeldung bearbeiten",
    yourRegistrationNumber: "Ihre Anmeldungsnummer lautet",
    openPrintView: "Druckansicht Ihrer Anmeldung öffnen",

    noEventData: "Fehlerhafte Veranstaltungsdaten!",
    pleaseReloadPage: "Die Veranstaltung wurde nicht oder nur unvollständig geladen. Um Fehler zu vermeiden laden Sie bitte die Seite neu!",
    pleaseReloadPageForVersion: "Sie arbeiten mit einer veralteten Version der Onlineanmeldung. Um Fehler zu vermeiden laden Sie bitte die Seite neu!",
    deprecatedVersion: "Veraltete Anmeldungsseite",

    loadingDocument: "Ihr Dokument wird geladen",
    eventPrintView: "Druckansicht Ihrer Veranstaltung",
    eventPreContractualInfo: "Vorvertragliche Informationen Ihrer Veranstaltung",

    submitBlocked: "Bitte warten Sie {seconds}s",
    inputOwnAnswer: "Eigene Antwort eingeben",
    ownAnswer: "Eigene Antwort",
    addOwnAnswer: "Eigene Antwort hinzufügen",
    removeOptions: "Auswahl entfernen",
    new: "Neu"
}
